// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck
import React, { memo } from 'react';
import HotspotMedia from '../../common/ImageHotspot/HotspotMedia';
import Cover from '../Cover';
import { IData } from '../DisplayWidget/DisplayWidget.container';
import { useDisplayWidgetContext } from '../DisplayWidget/utils/context';
import GoogleBadgeDesign from '../GoogleBadgeDesign';
import { UseWindowDimensions } from '../collage/utils';
import ProductsOverlay from '../Modals/components/ProductsOverlay';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, Pagination } from 'swiper/modules';
import { MdKeyboardArrowUp, MdKeyboardArrowDown, MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';
import AiSummaryCard from '../AiSummaryCard';
import { CLICK_EVENTS, SOURCE_TYPES } from '../../contants';

const LinkedinView = React.lazy(() => import('../LinkedinView'));
const GoogleView = React.lazy(() => import('../GoogleView'));

const CarouselView = () => {
  const {
    showModal,
    albumData,
    clickMutate,
    setAlbumId,
    isGoogle,
    layout,
    shopifyData,
    isLinkedIn,
    setIsUploadModalOpen,
    fetchNextPost,
    isLoading,
  } = useDisplayWidgetContext();
  const { data }: { data: IData } = useDisplayWidgetContext();
  const galleryData = data?.result?.layout;
  const column = galleryData.galleryInformation.columns;
  const width = parseInt(column);

  const responsive = {
    mobile: {
      breakpoint: { max: 40000, min: 0 },
      items: width,
    },
    desktop: {
      breakpoint: { max: 600, min: 0 },
      items: 1,
    },
    super: {
      breakpoint: { max: 400, min: 0 },
      items: 1,
    },
  };

  const [activeIndex, setActiveIndex] = React.useState(0);

  const swiperRef = React.useRef(null); // Keep Swiper instance
  const lastRealIndexRef = React.useRef(0);

  const handleSlideChange = (swiper) => {
    const realIndex = swiper.realIndex;
    lastRealIndexRef.current = realIndex;
    setActiveIndex(realIndex);

    if (realIndex === albumData.length - 4 && !isLoading) {
      fetchNextPost();
    }
  };

  React.useEffect(() => {
    if (swiperRef.current && albumData.length > 0) {
      swiperRef.current.slideToLoop(lastRealIndexRef.current);
    }
  }, [albumData.length]);

  const { width: screenWidth } = UseWindowDimensions();
  const mobileView = screenWidth < 500;

  if (isGoogle) {
    return (
      <React.Fragment>
        <style>{`
      .idk-carousel-item{
        padding: 0 ${parseInt(layout?.galleryInformation?.postSpacing) / 2}px;
      }`}</style>
        <idk-div
          style={{
            gap: `${layout?.galleryInformation?.postSpacing}px`,
          }}
        >
          {isGoogle && (
            <idk-div
              style={{
                flexGrow: 1,
                height: '100%',
              }}
            >
              <GoogleBadgeDesign metaJson={data?.result?.metaJson} />
            </idk-div>
          )}
          <idk-div
            style={{
              // maxWidth:
              //   isGoogle && layout?.googleBadges?.showBadge
              //     ? !mobileView
              //       ? `calc(100vw - 350px)`
              //       : `calc(100vw - 32px)`
              //     : '100vw',
              height: '100%',
            }}
          >
            <Swiper
              modules={[Navigation, Autoplay, Pagination]}
              spaceBetween={!layout?.sliderSettings?.specialCarousel ? 20 : 0}
              centeredSlides={
                layout?.sliderSettings?.centeredSlides === undefined
                  ? albumData.length > layout?.galleryInformation?.columns
                    ? true
                    : false
                  : layout?.sliderSettings?.centeredSlides
                  ? true
                  : false
              }
              slidesPerView={1}
              autoplay={
                galleryData.sliderSettings.autoPlay == false
                  ? false
                  : {
                      delay: galleryData.sliderSettings.autoPlaySpeed,
                      disableOnInteraction: false,
                    }
              }
              loop={albumData.length > layout?.galleryInformation?.columns ? true : false}
              pagination={false}
              onSlideChange={handleSlideChange}
              // swipeToSlide={true}
              onInit={(swiper) => setActiveIndex(swiper.realIndex)}
              navigation={{
                nextEl: '.google-review .image-swiper-button-next',
                prevEl: '.google-review .image-swiper-button-prev',
                disabledClass: 'swiper-button-disabled',
              }}
              breakpoints={{
                0: {
                  slidesPerView: 1.25,
                  loop: true,
                  centeredSlides: false,
                },
                768: {
                  slidesPerView: 2,
                },
                992: {
                  slidesPerView: layout?.galleryInformation?.columns || 3,
                },
              }}
            >
              {layout?.aiSummary?.enabled && (
                <SwiperSlide>
                  <AiSummaryCard metaJson={data?.result?.metaJson} layout={layout} />
                </SwiperSlide>
              )}
              {albumData.map((row, id) => {
                return (
                  <SwiperSlide key={id} style={{ height: 'auto' }}>
                    <idk-div
                      class="zid-flex zid-items-center zid-justify-center"
                      style={{
                        height: '100%',
                        flexGrow: 1,
                        borderRadius: layout?.cardSettings?.cardBorder,
                      }}
                    >
                      <GoogleView data={row} />
                    </idk-div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
            {(albumData.length > layout?.galleryInformation?.columns || window?.screen?.width < 576) && (
              <idk-div class="google-review">
                <idk-div
                  class={`zid-absolute zid-z-[100] zid-flex zid-gap-3 zid-flex-col ${
                    layout?.sliderSettings?.arrowPosition == 'center' ? 'zid-left-[-15px]' : ''
                  } ${layout?.sliderSettings?.arrowPosition == 'outside' ? 'zid-left-[-45px]' : ''} ${
                    layout?.sliderSettings?.arrowPosition == 'inside' ? 'zid-left-[20px]' : ''
                  }`}
                  style={{ top: '50%', transform: 'translateY(-50%)' }}
                >
                  <idk-div
                    style={{ backgroundColor: layout?.sliderSettings?.arrowBackgroundColor }}
                    // style={{ backdropFilter: 'blur(10px)', backgroundColor: 'rgb(0, 0, 0)' }}
                    class="image-swiper-button-prev zid-cursor-pointer zid-bg-[#090a0b33] zid-shadow-lg zid-rounded-full zid-h-[40px] zid-w-[40px] zid-flex zid-items-center zid-justify-center"
                  >
                    <MdKeyboardArrowLeft color={layout?.sliderSettings?.arrowColor} fontSize={30} />
                  </idk-div>
                </idk-div>
                <idk-div
                  class={`zid-absolute zid-z-[100] zid-flex zid-gap-3 zid-flex-col ${
                    layout?.sliderSettings?.arrowPosition == 'center' ? 'zid-right-[-15px]' : ''
                  } ${layout?.sliderSettings?.arrowPosition == 'outside' ? 'zid-right-[-45px]' : ''} ${
                    layout?.sliderSettings?.arrowPosition == 'inside' ? 'zid-right-[20px]' : ''
                  }`}
                  style={{ top: '50%', transform: 'translateY(-50%)' }}
                >
                  <idk-div
                    style={{ backgroundColor: layout?.sliderSettings?.arrowBackgroundColor }}
                    // style={{ backdropFilter: 'blur(10px)', backgroundColor: 'rgb(0, 0, 0)' }}
                    class="image-swiper-button-next zid-cursor-pointer zid-bg-[#090a0b33] zid-shadow-lg zid-rounded-full zid-h-[40px] zid-w-[40px] zid-flex zid-items-center zid-justify-center"
                  >
                    <MdKeyboardArrowRight color={layout?.sliderSettings?.arrowColor} fontSize={30} />
                  </idk-div>
                </idk-div>
              </idk-div>
            )}
          </idk-div>
        </idk-div>
      </React.Fragment>
    );
  }

  if (isLinkedIn) {
    return (
      <React.Fragment>
        <style>{`
      .idk-carousel-item{
        padding: 0 ${parseInt(layout?.galleryInformation?.postSpacing) / 2}px;
      }`}</style>
        <idk-div
          style={{
            gap: `${layout?.galleryInformation?.postSpacing}px`,
          }}
        >
          <idk-div
            style={{
              maxWidth:
                isGoogle && layout?.googleBadges?.showBadge
                  ? !mobileView
                    ? `calc(100vw - 350px)`
                    : `calc(100vw - 32px)`
                  : '100vw',
              height: '100%',
            }}
          >
            <Swiper
              modules={[Navigation, Autoplay, Pagination]}
              spaceBetween={!layout?.sliderSettings?.specialCarousel ? 20 : 0}
              centeredSlides={albumData.length > layout?.galleryInformation?.columns ? true : false}
              slidesPerView={1}
              autoplay={
                galleryData.sliderSettings.autoPlay == false
                  ? false
                  : {
                      delay: galleryData.sliderSettings.autoPlaySpeed,
                      disableOnInteraction: false,
                    }
              }
              loop={albumData.length > layout?.galleryInformation?.columns ? true : false}
              pagination={false}
              onSlideChange={handleSlideChange}
              // swipeToSlide={true}
              onInit={(swiper) => setActiveIndex(swiper.realIndex)}
              navigation={{
                nextEl: '.image-swiper-button-next',
                prevEl: '.image-swiper-button-prev',
                disabledClass: 'swiper-button-disabled',
              }}
              breakpoints={{
                0: {
                  slidesPerView: 1.25,
                  loop: true,
                  centeredSlides: false,
                },
                768: {
                  slidesPerView: 2,
                },
                992: {
                  slidesPerView: layout?.galleryInformation?.columns || 3,
                },
              }}
            >
              {albumData.map((row, id) => {
                return (
                  <SwiperSlide key={id}>
                    <idk-div
                      key={id}
                      class="zid-flex zid-justify-center"
                      style={{
                        height: '100%',
                        flexGrow: 1,
                        borderRadius: layout?.cardSettings?.cardBorder,
                      }}
                    >
                      <LinkedinView data={row} />
                    </idk-div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </idk-div>
        </idk-div>
      </React.Fragment>
    );
  }

  if (albumData.length > 0) {
    return (
      <>
        <style>
          {`.swiper-container {
                width: 100%;
                padding: 0;
              }

              .swiper-slide {
                transition: transform 0.5s ease-in-out;
              }

              .swiper-slide.center {
                z-index: 1;
                transition: transform 0.5s ease-in-out;
              }

              .swiper-slide:not(.center) {
                opacity: ${!layout?.sliderSettings?.specialCarousel ? '1' : '0.7'};
                transform: ${!layout?.sliderSettings?.specialCarousel ? 'scale(1)' : 'scale(0.8)'};
                transition: transform 0.5s ease-in-out, opacity 0.5s ease-in-out;
              }
              .swiper-slide {
                height: auto;
                max-height: 100%;
                }
              }
              `}
        </style>

        <div className="swiper-container">
          <Swiper
            key="album-swiper"
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            modules={[Navigation, Autoplay, Pagination]}
            spaceBetween={!layout?.sliderSettings?.specialCarousel ? 20 : 0}
            centeredSlides={
              galleryData?.sliderSettings?.centeredSlides !== undefined
                ? galleryData?.sliderSettings?.centeredSlides
                : albumData.length > layout?.galleryInformation?.columns
                ? true
                : false
            }
            slidesPerView={1}
            autoplay={
              galleryData.sliderSettings.autoPlay == false
                ? false
                : {
                    delay: galleryData.sliderSettings.autoPlaySpeed,
                    disableOnInteraction: false,
                  }
            }
            loop={albumData.length > layout?.galleryInformation?.columns ? true : false}
            pagination={false}
            onSlideChange={(swiper) => {
              swiperRef.current = swiper;
              handleSlideChange(swiper);
            }}
            onInit={(swiper) => setActiveIndex(swiper.realIndex)}
            navigation={{
              nextEl: '.image-swiper-button-next',
              prevEl: '.post-slider .image-swiper-button-prev',
              disabledClass: 'swiper-button-disabled',
            }}
            breakpoints={{
              0: {
                slidesPerView: 1.5,
                loop: true,
                centeredSlides: false,
              },
              768: {
                slidesPerView: 2,
              },
              992: {
                slidesPerView: layout?.galleryInformation?.columns || 3,
              },
            }}
          >
            {albumData.slice(0, 1).map((row: any, id: number) => (
              <SwiperSlide
                style={{
                  borderRadius: layout?.cardSettings?.cardBorder,
                }}
                key={id}
                className={`zid-relative zid-w-full carousel-item ${
                  layout?.sliderSettings?.specialCarousel && activeIndex === id ? 'center' : ''
                }`}
              >
                <idk-div
                  class="zid-w-full idk-slide-content"
                  onClick={() => {
                    showModal(row, 'slider');
                    setAlbumId(row.id);
                    clickMutate(row.id, {
                      event: row.mediaType === SOURCE_TYPES.VIDEO ? CLICK_EVENTS.VIDEO_WATCH : CLICK_EVENTS.IMG_CLICK,
                    });
                  }}
                  style={{
                    borderRadius: layout?.cardSettings?.cardBorder,
                    height: window.innerWidth < 576.98 ? '100%' : galleryData.cardSettings.cardHeight,
                    border: `1px solid ${layout?.cardSettings?.cardBorderColor}`,
                  }}
                >
                  <HotspotMedia
                    row={row}
                    playFunctionality={false}
                    autoPlay={layout?.videoSettings?.videoAutoPlay}
                    preload={id < activeIndex + 3 || id >= albumData.length - 2 ? 'auto' : 'metadata'}
                    layout={layout}
                    style={{ borderRadius: layout?.cardSettings?.cardBorder }}
                  />
                </idk-div>
                {layout?.sliderSettings?.specialCarousel && (
                  <idk-div
                    class="zid-absolute zid-z-[100] zid-flex zid-gap-3 zid-flex-col zid-right-[10px]"
                    style={{ top: '50%', transform: 'translateY(-50%)' }}
                  >
                    <idk-div
                      style={{ backdropFilter: 'blur(10px)' }}
                      class="image-swiper-button-prev zid-cursor-pointer zid-bg-[#090a0b33] zid-rounded-full zid-h-[40px] zid-w-[40px] zid-flex zid-items-center zid-justify-center"
                    >
                      <MdKeyboardArrowUp color="#fff" fontSize={30} />
                    </idk-div>
                    <idk-div
                      style={{ backdropFilter: 'blur(10px)' }}
                      class="google-review image-swiper-button-next zid-cursor-pointer zid-bg-[#090a0b33] zid-rounded-full zid-h-[40px] zid-w-[40px] zid-flex zid-items-center zid-justify-center"
                    >
                      <MdKeyboardArrowDown color="#fff" fontSize={30} />
                    </idk-div>
                  </idk-div>
                )}
                {row?.products?.length > 0 && layout.gallerySettings.showProducts && (
                  <ProductsOverlay shopifyData={shopifyData} row={row}></ProductsOverlay>
                )}
              </SwiperSlide>
            ))}
            {layout?.gallerySiteUploads?.buttonShow && layout?.gallerySiteUploads?.buttonStyle === 'tile' && (
              <SwiperSlide
                style={{
                  borderRadius: layout?.cardSettings?.cardBorder,
                  height: 'auto',
                }}
                className={`zid-p-5 zid-relative zid-bg-gray-200 zid-w-full carousel-item idk-site-uploads-card ${
                  layout?.sliderSettings?.specialCarousel && activeIndex === id ? 'center' : ''
                }`}
              >
                <idk-div class="zid-text-xl zid-text-center zid-flex zid-items-center zid-justify-center zid-flex-col zid-h-full zid-w-full zid-gap-2">
                  <idk-div
                    class="zid-font-bold"
                    dangerouslySetInnerHTML={{ __html: layout?.gallerySiteUploads?.addSvg }}
                  ></idk-div>
                  <idk-div
                    class="zid-font-bold"
                    dangerouslySetInnerHTML={{ __html: layout?.gallerySiteUploads?.addDescriptionText }}
                  ></idk-div>
                  <idk-div
                    onClick={() => setIsUploadModalOpen(true)}
                    className="zid-flex zid-items-center zid-gap-2 zid-cursor-pointer zid-px-3 zid-py-1"
                    dangerouslySetInnerHTML={{ __html: layout?.gallerySiteUploads?.addButtonText }}
                  ></idk-div>
                </idk-div>
              </SwiperSlide>
            )}
            {albumData.slice(1).map((row: any, id: number) => (
              <SwiperSlide
                style={{
                  borderRadius: layout?.cardSettings?.cardBorder,
                }}
                key={id}
                className={`zid-relative zid-w-full carousel-item ${
                  layout?.sliderSettings?.specialCarousel && activeIndex === id ? 'center' : ''
                }`}
              >
                <idk-div
                  class="zid-w-full idk-slide-content"
                  onClick={() => {
                    showModal(row, 'slider');
                    setAlbumId(row.id);
                    clickMutate(row.id, {
                      event: row.mediaType === SOURCE_TYPES.VIDEO ? CLICK_EVENTS.VIDEO_WATCH : CLICK_EVENTS.IMG_CLICK,
                    });
                  }}
                  style={{
                    borderRadius: layout?.cardSettings?.cardBorder,
                    height: window.innerWidth < 576.98 ? '100%' : galleryData.cardSettings.cardHeight,
                    border: `1px solid ${layout?.cardSettings?.cardBorderColor}`,
                  }}
                >
                  <HotspotMedia
                    row={row}
                    playFunctionality={false}
                    autoPlay={layout?.videoSettings?.videoAutoPlay}
                    preload={id < activeIndex + 3 || id >= albumData.length - 3 ? 'auto' : 'none'}
                    layout={layout}
                    style={{ borderRadius: layout?.cardSettings?.cardBorder }}
                  />
                </idk-div>
                {layout?.sliderSettings?.specialCarousel && (
                  <idk-div
                    class="post-slider zid-absolute zid-z-[100] zid-flex zid-gap-3 zid-flex-col zid-right-[10px]"
                    style={{ top: '50%', transform: 'translateY(-50%)' }}
                  >
                    <idk-div
                      style={{ backdropFilter: 'blur(10px)' }}
                      class="image-swiper-button-prev zid-cursor-pointer zid-bg-[#090a0b33] zid-rounded-full zid-h-[40px] zid-w-[40px] zid-flex zid-items-center zid-justify-center"
                    >
                      <MdKeyboardArrowUp color="#fff" fontSize={30} />
                    </idk-div>
                    <idk-div
                      style={{ backdropFilter: 'blur(10px)' }}
                      class="image-swiper-button-next zid-cursor-pointer zid-bg-[#090a0b33] zid-rounded-full zid-h-[40px] zid-w-[40px] zid-flex zid-items-center zid-justify-center"
                    >
                      <MdKeyboardArrowDown color="#fff" fontSize={30} />
                    </idk-div>
                  </idk-div>
                )}
                {row?.products?.length > 0 && layout.gallerySettings.showProducts && (
                  <ProductsOverlay shopifyData={shopifyData} row={row}></ProductsOverlay>
                )}
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        {!layout?.sliderSettings?.specialCarousel &&
          (albumData.length > layout?.galleryInformation?.columns || window?.screen?.width < 576) && (
            <>
              <idk-div
                class={`post-slider zid-absolute zid-z-[100] zid-flex zid-gap-3 zid-flex-col ${
                  layout?.sliderSettings?.arrowPosition == 'center' ? 'zid-left-[-15px]' : ''
                } ${layout?.sliderSettings?.arrowPosition == 'outside' ? 'zid-left-[-45px]' : ''} ${
                  layout?.sliderSettings?.arrowPosition == 'inside' ? 'zid-left-[20px]' : ''
                }`}
                style={{ top: '50%', transform: 'translateY(-50%)' }}
              >
                <idk-div
                  style={{ backgroundColor: layout?.sliderSettings?.arrowBackgroundColor }}
                  // style={{ backdropFilter: 'blur(10px)', backgroundColor: 'rgb(0, 0, 0)' }}
                  class="image-swiper-button-prev zid-cursor-pointer zid-bg-[#090a0b33] zid-shadow-lg zid-rounded-full zid-h-[40px] zid-w-[40px] zid-flex zid-items-center zid-justify-center"
                >
                  <MdKeyboardArrowLeft color={layout?.sliderSettings?.arrowColor} fontSize={30} />
                </idk-div>
              </idk-div>
              <idk-div
                class={`zid-absolute zid-z-[100] zid-flex zid-gap-3 zid-flex-col ${
                  layout?.sliderSettings?.arrowPosition == 'center' ? 'zid-right-[-15px]' : ''
                } ${layout?.sliderSettings?.arrowPosition == 'outside' ? 'zid-right-[-45px]' : ''} ${
                  layout?.sliderSettings?.arrowPosition == 'inside' ? 'zid-right-[20px]' : ''
                }`}
                style={{ top: '50%', transform: 'translateY(-50%)' }}
              >
                <idk-div
                  style={{ backgroundColor: layout?.sliderSettings?.arrowBackgroundColor }}
                  // style={{ backdropFilter: 'blur(10px)', backgroundColor: 'rgb(0, 0, 0)' }}
                  class="image-swiper-button-next zid-cursor-pointer zid-bg-[#090a0b33] zid-shadow-lg zid-rounded-full zid-h-[40px] zid-w-[40px] zid-flex zid-items-center zid-justify-center"
                >
                  <MdKeyboardArrowRight color={layout?.sliderSettings?.arrowColor} fontSize={30} />
                </idk-div>
              </idk-div>
            </>
          )}
      </>
    );
  } else {
    return (
      <>
        {layout?.gallerySiteUploads?.buttonShow && layout?.gallerySiteUploads?.buttonStyle === 'tile' && (
          <SwiperSlide
            style={{
              borderRadius: layout?.cardSettings?.cardBorder,
              height: 'auto',
            }}
            className={`zid-p-5 zid-relative zid-bg-gray-200 zid-w-full carousel-item ${
              layout?.sliderSettings?.specialCarousel && activeIndex === id ? 'center' : ''
            }`}
          >
            <idk-div class="zid-text-xl zid-text-center zid-flex zid-items-center zid-justify-center zid-flex-col zid-h-full zid-w-full zid-gap-2">
              <idk-div
                class="zid-font-bold"
                dangerouslySetInnerHTML={{ __html: layout?.gallerySiteUploads?.addSvg }}
              ></idk-div>
              <idk-div
                class="zid-font-bold"
                dangerouslySetInnerHTML={{ __html: layout?.gallerySiteUploads?.addDescriptionText }}
              ></idk-div>
              <idk-div
                onClick={() => setIsUploadModalOpen(true)}
                className="zid-flex zid-items-center zid-gap-2 zid-cursor-pointer zid-px-3 zid-py-1"
                dangerouslySetInnerHTML={{ __html: layout?.gallerySiteUploads?.addButtonText }}
              ></idk-div>
            </idk-div>
          </SwiperSlide>
        )}
      </>
    );
  }
};

export function LeftArrow({ ...props }) {
  const { onClick } = props;
  const {
    carouselState: { currentSlide },
  } = props;

  if (currentSlide == 0) return <></>;

  return (
    <idk-div
      style={{ width: '30px', height: '30px', backgroundColor: 'rgba(0,0,0,0.5)' }}
      onClick={onClick}
      class={`idk_carasourl_arrow idk_carasourl_arrow_left zid-absolute zid-translate-y-[-50%] zid-top-[50%] zid-translate-x-[20px] zid-cursor-pointer zid-rounded-full zid-opacity-[0.7] zid-h-[36px] zid-w-[36px] zid-flex zid-items-center zid-justify-center`}
    >
      <svg height="20px" id="Layer_1" version="1.1" viewBox="0 0 512 512" width="20px" fill="#ffffff">
        <polygon points="352,115.4 331.3,96 160,256 331.3,416 352,396.7 201.5,256 " />
      </svg>
    </idk-div>
  );
}

export function RightArrow({ ...props }) {
  const { onClick, totalSlides } = props;
  const {
    carouselState: { currentSlide },
  } = props;

  if (currentSlide == totalSlides - 1) return <></>;
  return (
    <idk-div
      style={{ width: '30px', height: '30px', backgroundColor: 'rgba(0,0,0,0.5)' }}
      onClick={onClick}
      class={`idk_carasourl_arrow idk_carasourl_arrow_right zid-absolute zid-translate-y-[-50%] zid-right-0 zid-top-[50%] zid-translate-x-[-20px] zid-z-[100] zid-cursor-pointer zid-rounded-[99px] zid-opacity-[0.7] zid-h-[36px] zid-w-[36px] zid-flex zid-items-center zid-justify-center`}
    >
      <svg height="20px" id="Layer_1" version="1.1" viewBox="0 0 512 512" width="20px" fill="#ffffff">
        <polygon points="160,128.4 192.3,96 352,256 352,256 352,256 192.3,416 160,383.6 287.3,256 " />
      </svg>
    </idk-div>
  );
}

export default memo(CarouselView);
